import { useState, useCallback, useEffect } from 'react';
import axios from 'axios';

const useMonitoramentoGlobal = (apiUrl, condominioId) => {
  const [problemasGlobais, setProblemasGlobais] = useState({
    reservatorios: []
    // exaustores: [], // Futuro
    // portoes: [], // Futuro
    // iluminacao: [] // Futuro
  });
  
  const [estatisticas, setEstatisticas] = useState({
    total: 0,
    porTipo: { reservatorios: 0 }
  });
  
  const [ultimaVerificacao, setUltimaVerificacao] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const consultarProblemas = useCallback(async () => {
    setIsLoading(true);
    
    try {
      const response = await axios.get(`${apiUrl}/api/monitoramento/problemas/globais`, {
        headers: condominioId ? { 'x-condominio-id': condominioId } : undefined
      });
      
      if (response.data.sucesso) {
        setProblemasGlobais(response.data.dados.problemas);
        setEstatisticas({
          total: response.data.dados.estatisticas?.total || 0,
          porTipo: response.data.dados.estatisticas?.porTipo || { reservatorios: 0 }
        });
        setUltimaVerificacao(response.data.dados.problemas.ultimaVerificacao);
      }
    } catch (error) {
      // ✅ 401: Token expirado ou inválido
      if (error.response?.status === 401) {
        console.warn('Sessão expirada. Redirecionando para login...');
        localStorage.removeItem('token');
        window.location.href = '/login';
        return;
      }
      
      // ✅ 403: Sem permissão de acesso
      if (error.response?.status === 403) {
        console.error('Acesso negado:', error.response.data?.mensagem);
        return;
      }
      
      console.error('Erro ao consultar problemas:', error);
    } finally {
      setIsLoading(false);
    }
  }, [apiUrl, condominioId]);

  const forcarVerificacao = useCallback(async () => {
    setIsLoading(true);
    
    try {
      const response = await axios.post(`${apiUrl}/api/monitoramento/verificacoes`, null, {
        headers: condominioId ? { 'x-condominio-id': condominioId } : undefined
      });
      
      if (response.data.sucesso) {
        setProblemasGlobais(response.data.dados.problemas || { reservatorios: [] });
        setEstatisticas({
          total: response.data.dados.estatisticas?.total || 0,
          porTipo: response.data.dados.estatisticas?.porTipo || { reservatorios: 0 }
        });
        setUltimaVerificacao(response.data.dados.problemas?.ultimaVerificacao || null);
      }
      
      return response.data;
    } catch (error) {
      // ✅ 401: Token expirado
      if (error.response?.status === 401) {
        console.warn('Sessão expirada. Redirecionando para login...');
        localStorage.removeItem('token');
        window.location.href = '/login';
        return { sucesso: false, mensagem: 'Sessão expirada' };
      }
      
      // ✅ 403: Sem permissão (usuário não pode acessar este condomínio)
      if (error.response?.status === 403) {
        console.error('Acesso negado:', error.response.data?.mensagem);
        return { sucesso: false, mensagem: error.response.data?.mensagem || 'Acesso negado' };
      }
      
      // ✅ 429: Taxa excedida (apenas usuários comuns, admins não têm limite)
      if (error.response?.status === 429) {
        const retryAfter = error.response.data?.dados?.retryAfter || 60;
        console.warn(`Taxa de requisições excedida. Tente novamente em ${retryAfter}s`);
        return { 
          sucesso: false, 
          mensagem: `Muitas tentativas. Aguarde ${retryAfter}s`, 
          retryAfter 
        };
      }
      
      console.error('Erro ao forçar verificação:', error);
      return { sucesso: false, mensagem: error.response?.data?.mensagem || 'Erro ao verificar' };
    } finally {
      setIsLoading(false);
    }
  }, [apiUrl, condominioId]);

  useEffect(() => {
    if (!condominioId) return;
    consultarProblemas();
  }, [consultarProblemas, condominioId]);

  return { 
    problemasGlobais, 
    estatisticas,
    ultimaVerificacao,
    isLoading,
    consultarProblemas,
    forcarVerificacao,
    problemasReservatorios: problemasGlobais.reservatorios || [],
    // problemasExaustores: problemasGlobais.exaustores || [], // Futuro
    totalProblemas: estatisticas.total
  };
};

export default useMonitoramentoGlobal;
